const fetch = global.fetch;
export { fetch };
